var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoThunderstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-thunderstorm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-thunderstorm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0372626,15.7499265 C20.7769052,15.7499265 23,13.5274194 23,10.7871891 C23,8.04637124 20.7769052,5.82386409 18.0372626,5.82386409 C17.6517616,5.82386409 17.2774261,5.87205171 16.9171942,5.95549857 C16.2267009,3.66717419 14.1040949,2 11.5912867,2 C8.51785667,2 6.02737933,4.49106499 6.02737933,7.56449502 C6.02737933,7.67791223 6.03678179,7.78897882 6.04383364,7.90122072 C5.7088709,7.81072201 5.35804151,7.75783316 4.99545904,7.75783316 C2.78823089,7.75783316 1,9.54723936 1,11.7538799 C1,13.9605203 2.78823089,15.7499265 4.99545904,15.7499265 L18.0372626,15.7499265 Z M10.3964534,16.5 L8,20.2090037 L11.250765,20.2090037 L10.1116829,22.5 L15,18.7133191 L12.1766342,18.7133191 L13.9558414,16.5 L10.3964534,16.5 Z",
    id: "ico-storm",
    fill: "#44484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoThunderstorm);
export default __webpack_public_path__ + "static/media/ico-thunderstorm.5a81f85aed5d2e8935ebdfc2b8030563.svg";
export { ForwardRef as ReactComponent };